var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConeType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 196,
    viewBox: "0 0 288 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.457 52.6031C246.864 79.7173 269.745 114.788 284.708 140.15C288.694 146.905 288.246 155.424 282.77 161.039C266.056 178.181 234.468 199.669 195.905 194.85C185.989 193.611 177.045 192.443 168.963 191.387C129.665 186.253 110.725 183.778 99.4415 188.798C85.8377 194.85 -14.3356 179.115 1.74159 141.591C3.1811 136.66 35.1998 90.3195 74.1499 54.3487C75.043 32.7694 144.845 1.63762 160.044 1.63759C189.345 -4.43056 217.536 34.3589 221.457 52.6031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.011 11.1776C94.2752 1.81848 4.95743 128.167 2.57562 136.356C-12.9061 172.623 83.5571 187.831 96.657 181.982C109.757 176.132 133.575 180.812 189.548 187.831C226.466 192.461 256.747 171.961 272.913 155.442C278.383 149.854 278.827 141.358 274.86 134.619C249.168 90.975 199.554 18.0414 155.011 11.1776Z",
    fill: "#7FAD8F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_166_7844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9076 42.4759C89.5949 26.6951 125.698 9.33148 145.152 3.58213C151.686 1.65133 158.591 0.375211 165.343 1.28274C191.165 4.75343 213.692 39.2542 214.747 53.4544C215.939 69.5001 202.827 71.9687 195.675 62.0944C189.954 54.195 186.14 59.6259 184.948 63.3287C183.756 68.2659 179.465 78.1401 171.836 78.1401C162.3 78.1401 160.343 65.7727 159.917 62.0944C159.5 58.5 151.573 49.7516 149.189 62.0944C148.488 65.7234 147.229 69.1301 145.779 72.1308C141.961 80.0287 134.9 87.3527 126.128 87.4096C118.14 87.4614 115.814 79.7448 115.814 74.4373C118.675 50.739 114.622 48.1059 112.238 49.7516C101.277 55.8631 92.8635 58.5008 86.6468 59.2217C76.9718 60.3437 70.8048 50.0668 76.9076 42.4759Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.292 76.7025C197.253 90.7867 213.705 121.537 231.827 131.866M160.295 83.7446C159.5 100.176 162.202 135.856 179.37 147.123M95.9162 76.7025C83.1994 84.9183 56.0967 108.627 49.4204 137.734",
    stroke: "#667D6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_166_7844",
    x: 70.4742,
    y: 0.984375,
    width: 148.349,
    height: 94.4255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_166_7844"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_166_7844",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConeType);
export default __webpack_public_path__ + "static/media/cone_type.7814833eb52fd2041a564a33f32b5d7d.svg";
export { ForwardRef as ReactComponent };